import {inject} from '@angular/core';
import {ResolveFn} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

export const RouteTitleResolver =
	(title: string, prefix = 'DocCycle'): ResolveFn<string> =>
	() => {
		const translateService = inject(TranslateService);
		return `${prefix} - ${translateService.instant(title)}`;
	};
